module.exports = __webpack_public_path__ + "img/0xC2392DD3e3fED2c8Ed9f7f0bDf6026fcd1348453.3f3b298c.png";